import sortBy from 'lodash/sortBy';
import { ClassSubjectItems } from "@/containers/organization/classManagement/types";
import { StudentType } from "@/containers/humanResourceManagement/studentManagement/types";
import { TranscriptListType } from "@/containers/transcript/types";

const subjectMap: { [key: number]: ['SI', 'SII', 'SIII', 'OP'] | ['S', 'C', 'LA'] } = {
  1: ['SI', 'SII', 'SIII', 'OP'], // GLevel
  2: ['S', 'C', 'LA'], // ESL
};

export const getSubjectColumnsByOrder = (template: number, subjectListForExam: ClassSubjectItems) => {
  const dynamicColumns: { title: string, dataIndex: number, width: number }[] = [];
  const subjectMapArray = subjectMap?.[template] ?? [];

  subjectMapArray.forEach((item) => {
    const subjectDataArray = subjectListForExam?.[item] ?? [];
    subjectDataArray?.forEach((data) => {
      dynamicColumns.push({ title: data?.enName, dataIndex: data?.subjectId, width: 150 });
    })
  });

  return dynamicColumns;
};

export const getFormatData = (studentArray: StudentType[], transcriptList: TranscriptListType) => {
  const formatedSutdentArray = sortBy(studentArray, ['cramSeat']).map((item) => {
    const { userAccountId } = item;
    const transcript = transcriptList[userAccountId] ?? {};
    let scoreBase = 0;
    const averageScore = Object.values(transcript).reduce((acc, score) => {
      const formatedScore = isTextScore(score) ? textScoreList[score as keyof typeof textScoreList]?.average : score;

      formatedScore && scoreBase++;
      return acc + (formatedScore ? parseFloat(`${formatedScore}`) : 0);
    }, 0) / scoreBase;

    return { ...item, ...transcript, averageScore: (Math.round(averageScore * 10) / 10) || 0 };
  });

  return formatedSutdentArray;
};

export const textScoreList = {
  A: { up: 100, down: 90, average: 95, text: 'Outstanding' },
  B: { up: 89, down: 80, average: 85, text: 'Exceed Expectations' },
  C: { up: 79, down: 70, average: 75, text: 'Satisfactory' },
  D: { up: 69, down: 60, average: 65, text: 'Unsatisfactory' },
  F: { up: 59, down: 0, average: 55, text: 'Needs Improvement' },
};

export const isTextScore = (score: string | number) => {
  return score === 'A' || score === 'B' || score === 'C' || score === 'D' || score === 'F';
}